import { WorkOrder, WorkOrderDto } from '../api/types'

export const mapWorkOrder = (dto: WorkOrderDto): WorkOrder => ({
  id: dto.id,
  code: dto.code,
  status: dto.status,
  event_name: dto.event_name,
  event_location: dto.event_location,
  start_date: dto.start_date,
  end_date: dto.end_date,
  created_by: dto.created_by,
  reviewed_by: dto.reviewed_by,
  created_at: dto.created_at,
  updated_at: dto.updated_at,
  is_draft: dto.is_draft,
  operations_manager_id: dto.operations_manager_id,
  deletedItems: [],
  items: dto.items.map(item => ({
    id: item.id,
    name: item.name,
    asset_category_id: item.asset_category_id,
    asset_type_id: item.asset_type_id,
    amount: item.amount,
    available_amount: item.available_amount,
    asset_category_name: item.asset_category_name,
    remaining_amount: item.remaining_amount,
    damaged_amount: item?.damaged_amount,
    issued_amount: item?.issued_amount,
    lost_amount: item?.lost_amount,
    returned_good_condition_amount: item?.returned_good_condition_amount,
    remaining_amount_to_return: item.remaining_amount_to_return,
  })),
})
